import React, { useState } from 'react'
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import styles, { colors, windowTagStyle } from '../styles/global'
import Icon from '../Icon'
import AppPopover from '../UIComponents/ModalShell/AppPopover'
import { useSelector } from 'react-redux'
import DescriptionModal from '../UIComponents/FloatModals/DescriptionModal/DescriptionModal'
import { cleanTextMetaData, shrinkTagText } from '../../functions/Utils/parseTextUtils'
import useFloatPopupLock from '../../hooks/useFloatPopupLock'

export default function DescriptionTag({
    projectId,
    object,
    style,
    disabled,
    onDismissPopup,
    objectType,
    outline,
    updateDescription,
    compact,
}) {
    const mobile = useSelector(state => state.mobile)
    const tablet = useSelector(state => state.isMiddleScreen)
    const [isOpen, setIsOpen] = useState(false)
    const popupLock = useFloatPopupLock()
    const textLimit = mobile ? 15 : tablet ? 20 : 25
    const compactTextLimit = Math.round(textLimit * 0.6)

    const hidePopover = () => {
        setIsOpen(false)
        popupLock.release()
        if (onDismissPopup) onDismissPopup()
    }

    const showPopover = () => {
        if (!isOpen) {
            setIsOpen(true)
            popupLock.acquire()
        }
    }

    return (
        <AppPopover
            content={
                <DescriptionModal
                    projectId={projectId}
                    object={object}
                    closeModal={hidePopover}
                    objectType={objectType}
                    updateDescription={updateDescription}
                />
            }
            onClickOutside={hidePopover}
            isOpen={isOpen}
            position={['left', 'right', 'top', 'bottom']}
            padding={4}
            align={'end'}
            contentLocation={mobile ? null : undefined}
        >
            <TouchableOpacity onPress={showPopover} disabled={disabled} accessible={false}>
                <View style={[(outline ? otl : localStyles).container, style]}>
                    <Icon
                        name={'info'}
                        size={outline ? 14 : 16}
                        color={outline ? colors.UtilityBlue200 : colors.Text03}
                        style={compact && !outline ? compactStyles.icon : localStyles.icon}
                    />
                    {!outline && !mobile && (
                        <Text
                            style={[
                                styles.subtitle2,
                                !mobile && localStyles.text,
                                compact && compactStyles.text,
                                windowTagStyle(),
                            ]}
                        >
                            {shrinkTagText(
                                cleanTextMetaData(object.description, true),
                                compact ? compactTextLimit : textLimit
                            )}
                        </Text>
                    )}
                </View>
            </TouchableOpacity>
        </AppPopover>
    )
}

const localStyles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        backgroundColor: colors.Gray300,
        borderRadius: 12,
        alignItems: 'center',
        justifyContent: 'center',
        height: 24,
    },
    icon: {
        marginHorizontal: 4,
    },
    text: {
        color: colors.Text03,
        marginVertical: 1,
        marginRight: 10,
        marginLeft: 2,
    },
})

const otl = StyleSheet.create({
    container: {
        flexDirection: 'row',
        backgroundColor: 'transparent',
        borderRadius: 50,
        borderWidth: 1,
        borderColor: colors.UtilityBlue200,
        alignItems: 'center',
        justifyContent: 'center',
        height: 20,
        width: 20,
    },
    icon: {
        marginHorizontal: 3,
    },
})

const compactStyles = StyleSheet.create({
    icon: {
        marginHorizontal: 2.4,
    },
    text: {
        marginRight: 6,
        marginLeft: 1.2,
    },
})
